class LoadInView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (this.loaded) return;
        if (entry.isIntersecting) {
          const template = this.querySelector("template");

          if (template) {
            this.append(template.content);
          }
          this.loaded = true;
          this.observer?.disconnect();
        }
      },
      { rootMargin: "250px 100px 250px 100px" },
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get("load-in-view")) {
  customElements.define("load-in-view", LoadInView);
}
